import React, { useEffect, useRef, useState } from "react";
import colorSharp from "../assets/img/color-sharp.png";
// import "./Skills.css";
import CurvedLoop from "./CurvedLoop/CurvedLoop";

export const Skills = () => {
  const items = [
    { img: "", title: "Full-stack Development" },
    { img: "", title: "Web Development" },
    { img: "", title: "Frontend Development" },
    { img: "", title: "Backend Development" },
    { img: "", title: "UI/UX Design" },
    { img: "", title: "Android Development" },
    { img: "", title: "Application Testing" },
    { img: "", title: "Express" },
    { img: "", title: "React" },
    { img: "", title: "Vue" },
    { img: "", title: "Adonis" },
    { img: "", title: "Laravel" },
    { img: "", title: "SQL Server" },
    { img: "", title: "MySQL" },
    { img: "", title: "MongoDB" },
    { img: "", title: "Node.js" },
    { img: "", title: "NextJS" },
    { img: "", title: "JavaScript" },
    { img: "", title: "TypeScript" },
    { img: "", title: "PHP" },
    { img: "", title: "HTML" },
    { img: "", title: "Edge" },
    { img: "", title: "CSS" },
    { img: "", title: "Java" },
    { img: "", title: "Kotlin" },
    { img: "", title: "Python" },
    { img: "", title: "C" },
    { img: "", title: "Tailwind CSS" },
    { img: "", title: "Material UI (MUI)" },
    { img: "", title: "Bootstrap" },
    { img: "", title: "Tensorflow" },
    { img: "", title: "TF Lite" },
    { img: "", title: "OAUTH" },
    { img: "", title: "Application Programming Interfaces (API)" },
    { img: "", title: "Git" },
    { img: "", title: "GitHub" },
    { img: "", title: "Figma" },
    { img: "", title: "Postman" },
    { img: "", title: "Trello" },
    { img: "", title: "Scrum" },
    { img: "", title: "Agile" },
    { img: "", title: "Apache Jmeter" },
    { img: "", title: "System Testing" },
    { img: "", title: "Functionality Testing" },
    { img: "", title: "Performance Testing" },
    { img: "", title: "Volume Testing" },
    { img: "", title: "Stress Testing" },
    { img: "", title: "Nginx" },
    { img: "", title: "Docker" },
    { img: "", title: "Linux" },
    { img: "", title: "Android Jettpack" },
    { img: "", title: "Software Quality" },
    { img: "", title: "Test Cases" },
    { img: "", title: "Amazon EC2" },
    { img: "", title: "Amazon ECS" },
    { img: "", title: "Leadership" },
    { img: "", title: "Event Management" },
    { img: "", title: "Creative Problem Solving" },
    { img: "", title: "Teamwork" },
    { img: "", title: "Team Coordination" },
    { img: "", title: "Public Speaking" },
    { img: "", title: "Communication" },
    { img: "", title: "Team Management" },
    { img: "", title: "Attention to Detail" },
  ];

  const trackRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const [speed, setSpeed] = useState(0.5); // scroll speed (px per frame)

  // useEffect(() => {
  //   let raf;
  //   const step = () => {
  //     setOffset((prev) => {
  //       const track = trackRef.current;
  //       if (!track) return prev;

  //       const width = track.scrollWidth / 2;
  //       const next = prev + speed;
  //       return next >= width ? 0 : next;
  //     });
  //     raf = requestAnimationFrame(step);
  //   };
  //   raf = requestAnimationFrame(step);
  //   return () => cancelAnimationFrame(raf);
  // }, [speed]);

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div
            className="col-12"
            onMouseEnter={() => setSpeed(0.2)}
            onMouseLeave={() => setSpeed(0.5)}
          >
            <div className="skill-bx wow zoomIn overflow-hidden">
              <h2>Skills</h2>
              <p>Here are some of the skills I've mastered</p>
              {/* <div className="carousel-wrapper">
                <div
                  ref={trackRef}
                  className="carousel-track"
                  style={{
                    transform: `translateX(-${offset}px)`,
                  }}
                >
                  {[...items, ...items].map((item, i) => (
                    <div className="item" key={i}>
                      <h5>{item.title}</h5>
                    </div>
                  ))}
                </div>
              </div> */}
              <div className="carousel-wrapper">
                <CurvedLoop
                  marqueeText={items.map((item) => item.title).join(" ✦ ")}
                  speed={2}
                  curveAmount={0}
                  direction="right"
                  interactive={true}
                  className="custom-text-style"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        className="background-image-left"
        src={colorSharp}
        alt="Background cover"
      />
    </section>
  );
};
